const frequency = {
  Background: {
    "Bergamot- Mint": 45,
    "Ancient- Love": 47,
    "Alpine- Sol": 59,
    Glitch: 55,
    "Ancient- Wisdom": 41,
    Earth: 47,
    "Happy- Pink": 39,
    "Ethereal- Folds": 42,
    "Cairo- Aurora": 42,
    "Primordial- Soup": 35,
    "Acid- Warp": 52,
    "Radioactive- Athens": 43,
    "Sky- Blue": 46,
    Dune: 59,
    "Mycelium- Warp": 45,
    "Muse- Codex": 56,
    "Liquid- Gold": 47,
  },
  Thoth: {
    Wise: 84,
    Ethereal: 74,
    Oracle: 86,
    Midnight: 80,
    Athenian: 77,
    Synthwave: 86,
    Desert: 79,
    Beige: 84,
    Golden: 64,
    Radioactive: 86,
  },
  Features: {
    Feathers: 391,
    "Golden- Feathers": 409,
  },
  Beak: {
    "Golden- Beak": 215,
    "Metallic- Beak": 176,
    Beak: 195,
    "Blue- Beak": 214,
  },
  Eyes: {
    Discombobulating: 104,
    Academic: 110,
    "Evil- Eye": 104,
    Ethereum: 85,
    "Regular- Eye": 97,
    "Eye- Of- Horus": 104,
    Blotty: 104,
    "Deal- With- It": 92,
  },
  Books: {
    Composition: 173,
    "Wood- Tablet": 156,
    "Lapis- Tablet": 171,
    "Gold- Ingot": 148,
    "Fish- Tablet": 152,
  },
  Pens: {
    "Ethereal  Pen": 98,
    Knife: 103,
    Horn: 92,
    "Gold- Nugget": 108,
    "Ball- Point": 107,
    Obsidian: 80,
    Pencil: 118,
    Twig: 94,
  },
  Crosses: {
    Atomic: 109,
    "Thoth- Script": 84,
    "Muse- Codex": 111,
    "Ice- Shatter": 96,
    "Muse- Maze": 124,
    Flames: 101,
    "Electric- Thoth- Script": 83,
    "Golden- Flare": 92,
  },
  Scarves: {
    "Regal- Red": 121,
    Lasers: 109,
    Blotty: 130,
    Golden: 116,
    "Lily- Pads": 109,
    Moss: 113,
    Rust: 102,
  },
  Smoko: {
    Pipe: 168,
    None: 171,
    Cigar: 130,
    "Gold- Cigar": 163,
    "Ethereal- Pipe": 168,
  },
} as const;

export default frequency;
